import * as React from "react";
export const renderLeagueName = (leagueName, componentPrefix) => {
    return (React.createElement("div", { className: `rj-ev-list__${componentPrefix}__league-name` }, leagueName));
};
//# sourceMappingURL=renderLeagueName.js.map